import { render, staticRenderFns } from "./InputInformasiUmum.vue?vue&type=template&id=b0573216&scoped=true&"
import script from "./InputInformasiUmum.vue?vue&type=script&lang=js&"
export * from "./InputInformasiUmum.vue?vue&type=script&lang=js&"
import style0 from "./InputInformasiUmum.vue?vue&type=style&index=0&id=b0573216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0573216",
  null
  
)

export default component.exports